import styled from 'styled-components';

export const StyledMissionNotification = styled.div`
  h3 {
    margin: 0 0 0.5rem 0;
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  }

  p {
    margin: 0;
    font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
    font-size: ${({ theme }) => theme.fonts.sizes.small};
    line-height: 1.3;
    font-family: ${({ theme }) => theme.fonts.familySansPro};
  }


`;
